
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import BaseLogo from '@/components/reusable-components/typography/BaseLogo.vue'
import HeaderNavigation from '@/components/layout/header/HeaderNavigation.vue'
import HeaderAction from '@/components/layout/header/HeaderAction.vue'
import { namespace } from 'vuex-class'
import HeaderAuthentication from '@/components/layout/header/HeaderAuthentication.vue'
import HeaderMobileNavigation from '@/components/layout/header/HeaderMobileNavigation.vue'
import HeaderSwitcher from '@/components/layout/header/switcher/HeaderSwitcher.vue'
import { UserRole } from '@/types/UserRole.type'
import RouteName from '@/utils/RouteName'

const BLOCK_SELECTOR = 'header'
const User = namespace('user')
@Component({
    components: {
        HeaderMobileNavigation,
        HeaderAuthentication,
        HeaderAction,
        HeaderNavigation,
        BaseLogo,
        HeaderSwitcher,
    },
})
export default class HeaderLayout extends Vue {
    @Prop({ type: String, default: 'lead' }) menu!: 'lead' | 'disabled-member' | 'search-all'
    @Prop({ type: String, default: '' }) afterLoginRedirect!: string
    @Prop({ type: Boolean }) transparent!: boolean

    RouteName = RouteName

    @User.Getter isConnected!: boolean
    @User.Getter isLead!: boolean
    @User.Getter hasRole!: (role: UserRole) => boolean

    searchExpanded = false

    @Watch('isAuthenticated')
    async onAuthChanged(newValue: boolean, oldValue: boolean) {
        if (!oldValue && newValue) {
            await this.$store.dispatch('app/getHeaderConfiguration')
        }
    }

    get classList() {
        return [
            BLOCK_SELECTOR,
            {
                [`${BLOCK_SELECTOR}--transparent`]: this.transparent,
                [`${BLOCK_SELECTOR}--anonymous`]: !this.isAuthenticated,
            },
        ]
    }

    get classAction() {
        return [
            {
                'header__action--full': this.searchExpanded,
            },
        ]
    }

    get isAuthenticated() {
        return this.isConnected && !this.isLead
    }

    get mode() {
        return this.menu === 'search-all' ? 'search-all' : 'autocomplete'
    }

    async created() {
        if (this.isAuthenticated) {
            await this.$store.dispatch('app/getHeaderConfiguration')
        }
        document.addEventListener('mvb:header:autocomplete:expand', ((event: CustomEvent) => {
            this.onChangeSearchExpanded(event.detail.status || false)
        }) as EventListener)
    }
    onChangeSearchExpanded(status: boolean) {
        this.searchExpanded = status
    }
}
